import { env } from '../../lib/env/env';

export const intercomConfig = {
  INTERCOM_APP_ID: env.getString('INTERCOM_APP_ID') || 'z87x53ub',
};
